import { useDataGridFetcher } from '@/hooks/api/useDataGridFetcher';
import { AssetSearchResponse } from '@/api/generatedApi';
import { queryFunction, queryKey } from './query';
import { SelectedFilters } from '@/components/FilterData/types';
import { normalizeSearchQuery } from '@/components/Search/utils';
import { UUID } from '@/api/generatedApi';

export const useFetchCrossTenantMetadataSearch = ({
  assetId,
  assetTenantId,
  searchTenantId,
  searchQuery,
  selectedFilters,
  onError,
  enabled = true,
}: {
  assetId: UUID;
  assetTenantId: UUID;
  searchTenantId: UUID;
  searchQuery?: string;
  selectedFilters?: SelectedFilters;
  onError?: (error: Error) => void;
  enabled?: boolean;
}) => {
  const normalizedSearchQuery = normalizeSearchQuery(searchQuery);

  return useDataGridFetcher<AssetSearchResponse>({
    queryKey: parameters =>
      queryKey({
        assetId,
        assetTenantId,
        searchTenantId,
        searchQuery: normalizedSearchQuery,
        selectedFilters,
        ...parameters,
      }),
    queryFn: parameters =>
      queryFunction({
        assetId,
        assetTenantId,
        searchTenantId,
        searchQuery: normalizedSearchQuery,
        selectedFilters,
        ...parameters,
      }),
    onError,
    enabled,
  });
};
